import styled, { css } from 'styled-components'
import { GREY_MEDIUM } from '../../utils/colors'

type ContainerProps = {
  size?: 'sm' | 'md' | 'lg'
}

export const Container = styled.div<ContainerProps>`
  table {
    width: 100%;

    th, td {
      text-align: left;
      padding: 31px;
      font-size: 14px;
      line-height: 20px;
      color: ${GREY_MEDIUM};
    }

    td {
      vertical-align: middle;
      color: #001021;
      min-height: 85px;
      padding: 31px;
    }

    tbody tr:nth-child(odd) {
      background-color: #F9F9F9;
    }

    ${props => props.size === 'sm' && css`
      th, td {
        padding: 18px 31px;
      }
      thead {
        th {
          padding: 15px 31px;
        }
      }
    `}
  }
`
